import ContextMenuController from "@/js/Webmail/ContextMenuController";

export { ContextClickDirective as default };

const ContextClickDirective = {
  created(el, binding) {
    el.menu_data = binding.value.data || undefined;
    el.onClick = (event) => {
      ContextMenuController.setEvent(event);
      ContextMenuController.setTarget(el);
      binding.value.action(el.menu_data);
    }
  },

  async unmounted(el) {
    el.removeEventListener('click', el.onClick);
  },

  mounted(el) {
    el.addEventListener('click', el.onClick);
  },
}
